module.exports = __webpack_public_path__ + "img/default-avatar.881d558.png";